const logger = window?.ev_vp?.Logger || console;

export const logError = (...args) => {
  logger.error?.(...args);
};

export const logWarning = (...args) => {
  logger.warning?.(...args);
};

export const logInfo = (...args) => {
  logger.info?.(...args);
};

export const logCritical = (...args) => {
  logger.critical?.(...args);
};

export const logDebug = (...args) => {
  logger.debug?.(...args);
};
